export default {
  model: {
    severity: {
      notes: 'Name of severity property on alarm notification preferences',
      message: 'Severity',
    },
    email: {
      notes: 'Name of email property on alarm notification preferences',
      message: 'Email',
    },
    push: {
      notes: 'Name of push property on alarm notification preferences',
      message: 'Push',
    },
  },
};
